var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pin", class: { "pin--preview-box": _vm.previewBox } },
    [
      _c("div", { ref: "pin", staticClass: "pin__main" }),
      _vm.previewBox
        ? _c("div", {
            staticClass: "pin__preview-box",
            style: `width: ${_vm.pinBoxSize}px; height: ${_vm.pinBoxSize}px`,
          })
        : _vm._e(),
      false /* uploading && isLoggedIn */
        ? _c("div", {
            staticClass: "pin__preview-circle",
            style: `width: ${_vm.previewCircleSize}px; height: ${_vm.previewCircleSize}px`,
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }